import styled from 'styled-components'

export const StateRoot = styled.section`
    min-height: 300px;
    padding: 56px 24px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
`;

export const StateTitle = styled.h2`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const StateDescription = styled.p`
    max-width: 440px;
    margin: 0 0 14px;
    color: ${({ theme }) => theme.palette.colors.muted};
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.6;
`;
